import {Component} from '@angular/core';
import {OverviewListCreelPosition} from '@domain/textile-data/creel/overview-list-creel-position';
import {PreviewType} from '@presentation/pages/textile-data/creel/add/preview-type';
import {OverviewListYarnType} from '@presentation/pages/textile-data/yarn-type/overview/overview-list-yarn-type';
import {AssertionUtils, Color} from '@vdw/angular-component-library';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {isEqual, isUndefined} from 'lodash-es';

@Component({
  templateUrl: './grid-creel-preview-of-creel-position.component.html',
  styleUrls: ['./grid-creel-preview-of-creel-position.component.scss']
})
export class GridCreelPreviewOfCreelPositionComponent implements ICellRendererAngularComp {
  public yarnTypes: OverviewListYarnType[];
  public showRgbValues: boolean = false;
  public colors: Color[];

  private previewType: PreviewType;

  public agInit(params: any): void {
    this.showRgbValues = params.showRgbValues;
    const creelPositionForColors: OverviewListCreelPosition = params.value.creelPositionForColors;

    if (!AssertionUtils.isNullOrUndefined(params.value.colors)) {
      this.colors = params.value.colors;
    }

    if (!AssertionUtils.isNullOrUndefined(creelPositionForColors)) {
      this.colors = creelPositionForColors.getUniqueItems() as Color[];
    }

    const creelPositionForYarnTypes: OverviewListCreelPosition = params.value.creelPositionForYarnTypes;
    if (!AssertionUtils.isNullOrUndefined(creelPositionForYarnTypes)) {
      this.yarnTypes = creelPositionForYarnTypes.getUniqueItems() as OverviewListYarnType[];
    }

    if (!isUndefined(params.previewType)) {
      this.previewType = params.previewType;
    }
  }

  public refresh(params: any): boolean {
    return false;
  }

  public canShowColors(): boolean {
    return isEqual(this.previewType, PreviewType.COLOR);
  }

  public canShowYarnTypes(): boolean {
    return isEqual(this.previewType, PreviewType.YARN_TYPE);
  }
}
